export default {
  waitInit () {
    if (true) {
      return Promise.resolve()
    }
    return new Promise(resolve => {
      setTimeout(() => {
        resolve()
      }, 50)
    })
    .then(() => {
      return this.waitInit()
    })
  },
  getResourceList() {
    if(!'performance' in window) {
      return []
    }
    if (!window.performance.getEntriesByType) return []
    const resources = window.performance.getEntriesByType('resource')
    const reportList = []
    // 遍历各个资源加载的时间
    resources.map((resource) => {
      if (/webcollects|capture/.test(resource.name)) return // 上报不参考在内
      // 判断加载的时间超过200毫秒则上报
      if(resource.duration > 200) {
        reportList.push({
          name: encodeURIComponent(resource.name),
          category: resource.initiatorType,
          time: parseInt(resource.duration)
        })
      }
    })
    return reportList
  },
  reportResourceLoad() {
    this.waitInit()
      .then(() => {
        return this.getResourceList()
      })
      .then(list => {
        list.forEach(item => {
          this.resourceLoad({
            name: item.name,
            category: item.category,
            time: item.time
          })
        })
      })
  },
  // 资源加载情况
  resourceLoad({ name, category, time }) {
    let data = {
      a: 25455,
      b: '统计',
      ft: '项目资源加载时间',
      r: '音乐人',
      mid: window.$userInfo.mid,
      userid: window.$userInfo.userid,
      appid: window.$userInfo.appid,
      svar1: window.km_config_sign || '音乐人入驻',
      svar2: encodeURIComponent(name),
      svar3: category,
      svar4: parseInt(time),
    }
    window.pushBI(data)
  }
}
